module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/PS-b8a61d0b77191f1811007e47d29e6e83.png";